import { YandexMetrikaAbTestModule } from '@analytics/feature';
import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { SdvorTabBarItemComponent } from '@sdvor/shared/ui';
import { CmsConfig, provideDefaultConfig } from '@spartacus/core';
import { CustomHamburgerMenuComponent } from './custom-hamburger-menu.component';

@NgModule({
  imports: [NgIf, AsyncPipe, SdvorTabBarItemComponent, YandexMetrikaAbTestModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        HamburgerMenuComponent: {
          component: CustomHamburgerMenuComponent,
        },
      },
    }),
  ],
  declarations: [CustomHamburgerMenuComponent],
  exports: [CustomHamburgerMenuComponent],
})
export class CustomHamburgerMenuModule {}
